// 2020-06-27export { TropaSeguimientoCorralListComponent } from './tropa-seguimiento-corral-list.component';